import "./iframesCarousel.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, { useContext, useEffect, useState } from "react";

import LayoutContext from "../../../contexts/layoutContext";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Slider from "react-slick";
import { findRel } from "../../../shared/utils/stringUtilities";
import getAlign from "../../../adapters/getAlign";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

const IframesCarousel = (props: any) => {
  const selectorClass = "cfmuiIframesCarousel";
  const {
    tituloGeneral,
    referenciaPlantillaContenido,
    tituloBoton,
    nombreCategoria,
  } = props;
  const context = useContext(LayoutContext);
  const [indexService, setindexService] = useState<any>(0);
  const component = (dots) => {
    return (
      <div style={{ bottom: "0px" }}>
        <ul> {dots} </ul>
      </div>
    );
  };

  const setting = {
    className: selectorClass + "__slider",
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 0.7,
    initialSlide: 0,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: false,
          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: false,
          dots: true,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          variableWidth: false,
          appendDots: (dots) => component(dots),
        },
      },
    ],
  };
  const [slider, setSlider] = useState<any>();
  const previous = (e) => {
    e.stopPropagation();
    slider.slickPrev();
  };
  const next = (e) => {
    e.stopPropagation();
    slider.slickNext();
  };
  useEffect(() => {
    if (context.slideServices?.get)
      setindexService(context.slideServices?.get - 1);
  }, [context.slideServices?.get]);

  return (
    <div
      className={`${selectorClass} ${
        props.alineacion
          ? `${selectorClass}--align-${getAlign(props.alineacion)}`
          : ""
      }`}
    >
      <div className={`${selectorClass}__container`}>
        <h2 className={`${selectorClass}__title`}>{tituloGeneral}</h2>
        <div style={{ position: "relative" }}>
          <Slider
            {...setting}
            ref={(c) => {
              setSlider(c);
            }}
          >
            {referenciaPlantillaContenido.map((val, key) => {
              return (
                <div key={key} className={`${selectorClass}__iframeContainer`}>
                  <iframe
                    src={val.redireccionBoton}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                </div>
              );
            })}
          </Slider>
          <div
            className={`${selectorClass}__arrow ${selectorClass}__arrow--left ${
              referenciaPlantillaContenido.length > 1 ? "shown" : "hiden"
            }`}
            onClick={previous}
          >
            <div className="icon-chevron-left active" />
          </div>
          <div
            className={`${selectorClass}__arrow ${selectorClass}__arrow--right ${
              referenciaPlantillaContenido.length > 1 ? "shown" : "hiden"
            }`}
            onClick={next}
          >
            <div className="icon-chevron-right active" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IframesCarousel;
